import type { IVisitaRepository } from '@/domain/repositories/IVisitaRepository';
import type { CreateVisitaDTO } from '@/application/dto/visitas/CreateVisitaDTO';

export class CreateVisitaUseCase {
  constructor(private readonly repository: IVisitaRepository) {}

  execute(data: CreateVisitaDTO) {
    return this.repository.create(data);
  }
}
